import {
  JSX,
  MutableRefObject,
  createContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';

export const CartContext = createContext(
  {} as {
    cartRef: MutableRefObject<any>;
    showCart: () => void;
  },
);

export const CartProvider = (props: { children: JSX.Element }) => {
  const cartRef = useRef<any>(null);
  const DISPLAY_TIME_MILIS = 4500;

  const showCart = useCallback(() => {
    if (cartRef.current) {
      cartRef.current.show();

      setTimeout(() => cartRef.current.hide(), DISPLAY_TIME_MILIS);
    }
  }, [cartRef]);

  return (
    <CartContext.Provider
      value={useMemo(() => {
        return { cartRef, showCart };
      }, [cartRef, showCart])}
    >
      {props.children}
    </CartContext.Provider>
  );
};
